module.exports = __webpack_public_path__ + "static/media/anti__bg__3.04009fca.png";